<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="用户名" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input
            placeholder="请输入用户名"
            v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入用户名!' }],initialValue:userInfo.info.name}
        ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input
            placeholder="请输入密码"
            v-decorator="[
          'pwd',
          {rules: [{ required: isVal, message: '请输入密码!' },{max:16,message:'最大长度不能超过16'},{min:6,message:'最小长度为6'}]}
        ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="真实姓名" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input
            placeholder="请输入真实姓名"
            v-decorator="[
          'relaname',
          {rules: [{ required: true, message: '请输入真实姓名!' }],initialValue:userInfo.info.realname}
        ]"
          ></a-input>
        </a-form-item>

        <a-form-item label="手机号码" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input
            placeholder="请输入手机号码"
            v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入手机号码!' },{ pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/, message: '手机号格式不正确!' }],initialValue:userInfo.info.telephone}
        ]"
          ></a-input>
        </a-form-item>

        <a-form-item label="用户角色" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-transfer
            :dataSource="rolesAll"
            showSearch
            :filterOption="filterOption"
            :targetKeys="userInfo.roles"
            @change="handleChange"
            :render="item=>item.title"
            :listStyle="{ height: '300px'}"
            v-decorator="[
          'roles',
          {rules: [{ required: true, message: '请选择角色!' }],initialValue:userInfo.roles}
        ]"
          ></a-transfer>
        </a-form-item>

        <a-form-item label="用户状态" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-switch
            v-model="userInfo.info.status"
            checkedChildren="启用"
            unCheckedChildren="禁用"
            v-decorator="[
          'status',
          {rules: []}
        ]"
          />
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
          <pxkeji-btn name="确认" type="primary" htmlType="submit" />
          <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
        </a-form-item>
      </a-form>
    </div>
  </a-spin>
</template>

<script>
var that;

export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      dis: this.disabled,
      userInfo: {
        roles: [],
        info: {
          status: false
        }
      },
      isVal: false,
      rolesAll: [],
      isloading: false,
      loadingTip: "加载中..."
    };
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      this.getRolesAll();
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    sumbit() {
      this.$emit("callbackMethod");
    },
    handleSubmit(e) {
      //提交
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.infos.id) {
            //修改
            this.isloading = true;
            this.$api.user
              .update(
                this.infos.id,
                values.name,
                values.phone,
                values.relaname,
                values.roles.join(","),
                values.status
                  ? this.$commen.changeBooleanInt(values.status)
                  : this.$commen.changeBooleanInt(this.userInfo.info.status),
                this.userInfo.info.headUrl?this.userInfo.info.headUrl:"",
                this.userInfo.info.gender?this.userInfo.info.gender:"",
                this.userInfo.info.nickName?this.userInfo.info.nickName:"",
                values.pwd
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod", true);
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //新增
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.user
              .save(
                values.name,
                values.phone,
                values.relaname,
                values.roles.join(","),
                values.status
                  ? this.$commen.changeBooleanInt(values.status)
                  : this.$commen.changeBooleanInt(this.userInfo.info.status),
                this.userInfo.info.headUrl?this.userInfo.info.headUrl:"",
                this.userInfo.info.gender?this.userInfo.info.gender:"",
                this.userInfo.info.nickName?this.userInfo.info.nickName:"",
                values.pwd
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod", true);
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },
    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1;
    },
    handleChange(targetKeys, direction, moveKeys) {
      this.userInfo.roles = targetKeys;
    },
    getRolesAll() {
      this.isloading = true;
      this.$api.role
        .getForAdmin()
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            for (var i = 0; i < res.data.length; i++) {
              var infoaa = {
                key: res.data[i].id + "",
                title: res.data[i].name
              };
              this.rolesAll.push(infoaa);
            }

            if (this.infos.id) {
              this.isVal = false;
              this.getUserInfo();
            } else {
              this.isVal = true;
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    getUserInfo() {
      this.isloading = true;
      this.$api.user
        .getById(this.infos.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            res.data.status = this.$commen.changeIntBoolean(res.data.status);
            this.userInfo.info = res.data;

            this.userInfo.info.realname = res.data.realName;

            this.userInfo.roles = [];
            for (var i = 0; i < res.data.roles.length; i++) {
              this.userInfo.roles.push(res.data.roles[i].id + "");
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>